<template>
  <v-dialog
    :value="dialog"
    max-width="600"
    @input="onRegisterDialogInput"
  >
    <v-card>
      <v-card-text class="py-4">
        <v-form
          ref="registerForm"
          v-model="form"
          lazy-validation
          class="px-5"
        >
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <h2 class="headline font-weight-regular primary--text pb-5">
                Registrar
                <v-btn
                  icon
                  class="float-right primary--text"
                  @click="onRegisterDialogInput(false)"
                >
                  <v-icon>fas fa-times</v-icon>
                </v-btn>
              </h2>
              <p class="font-weight-light pb-0 mb-0">
                Para visualizar o documento você precisa
                fazer um registro preenchendo os dados abaixo;
              </p>
            </v-col>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                :value="registerAccount.name"
                :rules="[rules.required]"
                label="Nome *"
                placeholder="Digite seu nome *"
                required
                @input="onRegisterAccountPatch({name: $event})"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pb-0"
            >
              <v-text-field
                :value="registerAccount.email"
                :rules="[rules.emailRules, rules.required]"
                label="E-mail *"
                type="email"
                placeholder="Digite seu e-mail *"
                required
                @input="onRegisterAccountPatch({email: $event})"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pb-0"
            >
              <v-text-field
                :value="registerAccount.phone"
                v-mask="['+55 (##) ####-####', '+55 (##) #####-####']"
                label="Telefone"
                type="tel"
                placeholder="Digite seu telefone"
                @input="onRegisterAccountPatch({phone: $event})"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pb-0"
            >
              <v-text-field
                :value="registerAccount.company"
                label="Instituição"
                placeholder="Instituição"
                @input="onRegisterAccountPatch({company: $event})"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pb-0"
            >
              <v-select
                label="Escolaridade *"
                placeholder="Escolaridade *"
                :items="['Ensino Fundamental',
                        'Ensino Médio',
                        'Ensino Superior',
                        'Ensino Fundamental Incompleto',
                        'Ensino Médio Incompleto',
                        'Ensino Superior Incompleto']"
                :value="registerAccount.education"
                hide-details
                required
                :rules="[rules.required]"
                @input="onRegisterAccountPatch({education: $event})"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pb-0"
            >
              <v-text-field
                :value="registerAccount.password"
                :rules="[rules.required, rules.min8]"
                label="Senha *"
                :append-icon="showPass1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                :type="showPass1 ? 'text' : 'password'"
                placeholder="Digite sua senha *"
                required
                @click:append="showPass1 = !showPass1"
                @input="onRegisterAccountPatch({password: $event})"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pb-0"
            >
              <v-text-field
                v-model="password"
                :rules="[v => v === registerAccount.password ||
                            'As senhas precisam ser iguais']"
                :append-icon="showPass2 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                :type="showPass2 ? 'text' : 'password'"
                label="Repita sua senha *"
                placeholder="Repita sua senha *"
                validate-on-blur
                required
                @click:append="showPass2 = !showPass2"
              />
            </v-col>
            <v-col
              cols="12"
              class="py-2 d-flex align-center"
            >
              <v-checkbox
                v-model="agree"
                class="mt-0"
                hide-details
              >
              </v-checkbox>
              <div>
                Li e concordo com os
                <a
                  target="_blank"
                  href="/Termo-de-Responsabilidade-Centro-de-Memoria.pdf"
                >
                  termos de uso e privacidade.
                </a>
              </div>
            </v-col>
          </v-row>
          <v-row class="pt-5 text-right">
            <small>* campos obrigatórios</small>
            <v-spacer />
            <v-btn
              text
              color="accent"
              class=" mr-4"
              @click="onRegisterDialogInput(false); goToLogin()"
            >
              Já tenho registro
            </v-btn>
            <v-btn
              rounded
              :loading="loading"
              color="primary"
              :block="$vuetify.breakpoint.smAndDown"
              :disabled="!agree"
              @click="onRegister($refs.registerForm)"
            >
              Registrar
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import formRules from '@/mixins/form-rules';

export default {
  name: 'DeleteDialog',
  mixins: [formRules],
  data() {
    return {
      form: false,
      password: null,
      showPass1: false,
      showPass2: false,
      agree: false,
    };
  },
  props: {
    onRegister: {
      type: Function,
      required: true,
    },
    onRegisterDialogInput: {
      type: Function,
      required: true,
    },
    onRegisterAccountPatch: {
      type: Function,
      required: true,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    registerAccount: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToLogin() {
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>
